export default function() {
  return new Worker(__webpack_public_path__ + "parseNftDataToCanvas.worker.f353547339a027fcc1ee.worker.js");
}
